export default __webpack_public_path__ + "static/media/ep_10.2af26edf.png";